
import { DomainRegistry } from "@/domain";
import { FileHeader } from "@/domain/file";
import { FolderDispInfo } from "@/domain/folder";
// import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class FileListMixin extends Mixins() {
  data(): any {
    return {
      isLoading: false,
      displaySetting: null,
    };
  }
  isLoading: boolean;
  displaySetting: FolderDispInfo;

  async created(): Promise<void> {
    await this.getDisplaySetting();
  }

  async getDisplaySetting(): Promise<void> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.folder.getFolderRepository();
      const result = await repository.getFolderDispInfo();
      this.isLoading = false;
      
      this.displaySetting = result;
    }
    catch (e) {
      this.isLoading = false;
      this.$error("エラー", "表示設定の取得に失敗しました。")
    }
  }

  async getFileList(folderGuid: string): Promise<FileHeader[]> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.file.getFileRepository();
      return await repository.getFileHeaders(folderGuid);
    } catch (e) {
      this.$error("ファイル一覧取得エラー", "ファイル一覧の取得中にエラーが発生しました。", e);
    } finally {
      this.isLoading = false;
    }
  }

  async deleteFile(folderGuid: string, fileId: string): Promise<boolean> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.file.getFileRepository();
      await repository.deleteFile(folderGuid, fileId);
      return true;
    } catch (e) {
      this.$error("ファイル削除エラー", "ファイル削除中にエラーが発生しました。", e);
      return false;
    } finally {
      this.isLoading = false;
    }
  }

  downloadFiles(folderGuid: string): void {
    try {
      const repository = DomainRegistry.file.getFileRepository();
      const url = repository.downloadBatchFiles(folderGuid);
      this.downloadFile(url)
    } catch (e) {
      this.$error("一括ダウンロード", "一括ダウンロード中にエラーが発生しました。", e);
    }
  }

  private downloadFile(url: string): void {
    window.location.href = url;
  }
}
